import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './SignInSuccess.css';

function SignInSuccess() {
  const navigate = useNavigate();

  useEffect(() => {
    // Auto-redirect to home after 3 seconds
    const timer = setTimeout(() => {
      navigate('/');
    }, 3000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="success-page">
      <main className="success-main">
        <div className="success-container">
          <div className="success-icon">✓</div>
          <h1 className="success-title">Thanks for signing in</h1>
          <p className="success-subtitle">Welcome to Sound Disposition</p>
          <p className="success-message">Redirecting...</p>
        </div>
      </main>
    </div>
  );
}

export default SignInSuccess;
